import { all, call, select, takeEvery } from 'redux-saga/effects';
import { selectActiveVenueId, selectRouteQuery } from 'selectors/general';
import { fetchEntity, fetchEntityIfNeeded } from '@classpass/saga-tools';
import { reportsCampaigns as reportsCampaignsEntity, campaigns as campaignsEntity } from 'store/saga/entities/bound';
import { makePath } from 'helpers/link-generation';
import { SET_ROUTE_QUERY } from 'reducers/route';
import { REPORT_TYPES } from 'features/Stats/Stats.constants';

import {
  selectCampaignsReportCampaignTypeId,
  selectCampaignsReportStartDateString,
  selectCampaignsReportEndDateString,
} from './Campaigns.selectors';

export const UPDATE_FILTER = 'stats/campaigns/UPDATE_FILTER';

export const updateFilter = (key, value) => ({
  type: UPDATE_FILTER,
  key,
  value,
});

export const triggerRouteEnter = () => ({
  type: SET_ROUTE_QUERY,
});

export function* handleRouteEnter(dependencies) {
  const venueId = yield select(selectActiveVenueId);
  const startDate = yield select(selectCampaignsReportStartDateString);
  const endDate = yield select(selectCampaignsReportEndDateString);
  const campaignTypeId = yield select(selectCampaignsReportCampaignTypeId);

  yield all([
    call(fetchEntityIfNeeded, campaignsEntity, [dependencies, campaignsEntity.method.options, { venueId }]),
    call(fetchEntity, reportsCampaignsEntity, [dependencies, { campaignTypeId, endDate, startDate, venueId }]),
  ]);
}

export function* doUpdateFilter(dependencies, action) {
  const query = yield select(selectRouteQuery);
  const { key, value } = action;
  let params;
  if (value === null) {
    params = { ...query };
    delete params[key];
  } else {
    params = { ...query, [key]: value };
  }

  yield call(dependencies.navigate, makePath.reports({ reportType: REPORT_TYPES.CAMPAIGNS }, params));
}

export function* watchActions(dependencies) {
  yield takeEvery(UPDATE_FILTER, doUpdateFilter, dependencies);
  yield takeEvery(SET_ROUTE_QUERY, handleRouteEnter, dependencies);
}
